import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ServicesView from '@/views/ServicesView.vue'; // Página de servicios
import PrivacyPolicyView from '@/views/PrivacyPolicyView.vue'
import TermsAndConditionsView from '@/views/TermsAndConditionsView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/servicios',
    name: 'Services',
    component: ServicesView
  },
  {
    path: '/aviso-de-privacidad',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyView,
  },
  {
    path: '/terminos-y-condiciones',
    name: 'TermsAndConditions',
    component: TermsAndConditionsView,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
